import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { Field, Input } from '@hb/coffee';
import { trimAll, trimValue } from '@/shared/utils/trim';
import { validatorPersonName } from '@/shared/utils/validator';
import { InfoComplementField } from '@/components/new-info-complete/types';

@Component({ name: 'UserName' })
export default class UserName extends Vue implements InfoComplementField {
  @Prop()
  private value!: string;

  private userName = '';

  private errorMsg = '';

  /** 检验联系人姓名-正确性 */
  public onValidator(): boolean {
    const val = this.userName;

    if (val === undefined || val === null || val === '') {
      this.errorMsg = '请填写姓名';
      return false;
    }

    if (!validatorPersonName(val)) {
      this.errorMsg = '姓名只能包含2～25个汉字';
      return false;
    }

    /** 联系人姓名不能包含敏感字符 */
    const sensitiveCharacter = this.checkSensitiveName(val);
    if (sensitiveCharacter) {
      this.errorMsg = `姓名不能包含【${sensitiveCharacter}】等称谓词`;
      return false;
    }

    return true;
  }

  private created() {
    if (this.value) {
      this.userName = this.value;
    }
  }

  @Watch('value')
  private onPropsValueChange(val: string) {
    /** 删除空格字符 */
    this.userName = trimAll(val);
  }

  /** 联系人姓名不能包含敏感字符 */
  private checkSensitiveName(val: string): string | undefined {
    const trimVal = trimValue(val);
    // 当前需要校验的联系人名字敏感字符
    const SentiveNameList = [
      '姥', '爷', '婆', '公', '奶',
      '爸', '妈', '叔', '姨', '舅',
      '哥', '兄', '姐', '弟', '妹',
      '丈夫', '老公', '老婆', '妻子', '媳妇',
      '父', '母', '伯', '婶', '姑',
      '婿', '嫂',
    ];
    const checkNameRes = SentiveNameList.find(
      (item) => trimVal.indexOf(item) > -1,
    );

    return checkNameRes;
  }

  private onChangeName(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onFocus() {
    this.$emit('focus');
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  private render() {
    return (
      <Field
        label="姓名"
        errorMessage={this.errorMsg}
      >
        <Input
          v-model={this.userName}
          placeholder="请填写姓名"
          on={{
            'update:modelValue': (val: string) => {
              this.onChangeName(val);
            },
          }}
          onFocus={this.onFocus.bind(this)}
          onBlur={this.onBlur.bind(this)}
        />
      </Field>
    );
  }
}
